// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__7EBH5","waves":"Button_waves__1Ik-Y","Active":"Button_Active__3-RSy","Danger":"Button_Danger__3GItt","Parent":"Button_Parent__1fDkb"};